(() => {
  if (customElements.get('glowen-product-visitors')) return;
  const records = new Map();
  const events = new Map();
  const identityKey = 'glowen:product-visitor:v1';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const api = 'https://glowen-quiz-stats.onrender.com/product-views';
  const request = (url, options = {}) => fetch(url, {
    credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(5000), ...options,
  });
  function visitorId() {
    try {
      let entry = JSON.parse(localStorage.getItem(identityKey) || 'null');
      if (!entry || entry.expires < Date.now() || !/^[a-f0-9-]{36}$/i.test(entry.id)) {
        entry = { id: crypto.randomUUID() };
      }
      entry.expires = Date.now() + 86400000;
      localStorage.setItem(identityKey, JSON.stringify(entry));
      return entry.id;
    } catch { return null; }
  }
  class ProductVisitors extends HTMLElement {
    get windowHours() {
      return this.dataset.metric === 'views' && this.dataset.windowHours === '48' ? 48 : 24;
    }
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.onConsent = () => { void this.updateConsent(); };
      document.addEventListener('visitorConsentCollected', this.onConsent);
      this.refresh = () => { if (!document.hidden) void this.read(); };
      document.addEventListener('visibilitychange', this.refresh);
void this.read().then(() => this.updateConsent());
      this.interval = setInterval(this.refresh, 60000);
      if (!window.Shopify?.customerPrivacy) {
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], error => {
          if (!error && this.isConnected) void this.updateConsent();
        });
      }
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visitorConsentCollected', this.onConsent);
      document.removeEventListener('visibilitychange', this.refresh);
      this.started = false;
    }
    paint(data) {
      if (!this.isConnected) return;
      const count = data?.count;
      const isViews = this.dataset.metric === 'views';
      if (!Number.isSafeInteger(count) || count < (isViews ? 11 : 1) || (isViews && data.metric !== 'views') || data.channel !== this.dataset.channel || data.windowHours !== this.windowHours) {
        this.hidden = true;
        return;
      }
      const locale = this.dataset.locale || 'en';
      let category = 'other';
      try { category = new Intl.PluralRules(locale).select(count); } catch {}
      const label = this.dataset[category] || this.dataset.other;
      const text = this.querySelector('[data-visitor-text]');
      if (!text || !label) return;
      text.textContent = label.replace('__COUNT__', new Intl.NumberFormat(locale).format(count));
      this.hidden = false;
    }
    async read() {
      try {
        const response = await request(`${api}/${this.dataset.productId}?channel=${this.dataset.channel}&metric=${this.dataset.metric === 'views' ? 'views' : 'visitors'}&windowHours=${this.windowHours}`);
        if (!response.ok) throw new Error('unavailable');
        this.paint(await response.json());
      } catch { this.hidden = true; }
    }
    async updateConsent() {
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) return;
      if (!allowed()) {
        try {
          const old = JSON.parse(localStorage.getItem(identityKey) || 'null');
          localStorage.removeItem(identityKey);
          records.clear();
          if (old?.id) {
            await request(api, { method: 'DELETE', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ channel: this.dataset.channel, visitorId: old.id }) });
            await this.read();
          }
        } catch {}
        return;
      }
      const id = visitorId();
      if (!id || window.Shopify?.designMode) return;
      const metric = this.dataset.metric === 'views' ? 'views' : 'visitors';
      const key = `${metric}:${this.windowHours}:${this.dataset.channel}:${this.dataset.productId}:${id}`;
      if (metric === 'views' && !events.has(key)) events.set(key, crypto.randomUUID());
      if (!records.has(key)) {
        const send = request(api, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ channel: this.dataset.channel, productId: this.dataset.productId, visitorId: id, analyticsAllowed: true, metric, windowHours: this.windowHours, ...(metric === 'views' ? { eventId: events.get(key) } : {}) }),
        }).then(async response => {
          if (!response.ok || response.status === 204) throw new Error('not-recorded');
          return response.json();
        }).catch(() => { records.delete(key); return null; });
        records.set(key, send);
      }
      const result = await records.get(key);
      if (result) this.paint(result);
    }
  }
  customElements.define('glowen-product-visitors', ProductVisitors);
})();
